/*
 * @Description:
 * @Date: 2020-07-27 11:25:02
 */
const wsProtocol = location.protocol === 'https:' ? 'wss' : 'ws';
const href = window.location.href;
const setDomain = () => {
  let hostname = window.location.hostname;
  let len = 0;
  if (!hostname.includes('192') && !hostname.includes('172')) {
    hostname = hostname.split('.');
    len = hostname.length;
    hostname = `${hostname[len - 2]}.${hostname[len - 1]}`;
  }
  return hostname;
};

let difObj = {};

if (/jimijiayuan/.test(href)) {
  // 测试环境
  difObj = {
    wxAppId: 'wxe37f12b1fa076c1a',
    webSocketPath: `${wsProtocol}://danmu.jimijiayuan.cn`,
    wxAccount: 'xiaowei',
    env: '105',
    ysh: `//ysh-wxv2.jimijiayuan.cn/html/newWechat.html?t=${Date.now()}/#/home?from=jhss`
  };
} else if (/192\.168/.test(href)) {
  difObj = {
    wxAppId: 'wxe37f12b1fa076c1a',
    webSocketPath: `${wsProtocol}://danmu.jimijiayuan.cn`,
    wxAccount: 'xiaowei',
    env: '105',
    ysh: `//ysh-wxv2.jimijiayuan.cn/html/newWechat.html?t=${Date.now()}/#/home?from=jhss`
  };
} else if (/myxrk\.cn/.test(href)) {
  // 预生产
  difObj = {
    wxAppId: 'wxe37f12b1fa076c1a',
    webSocketPath: `${wsProtocol}://danmu.jimijiayuan.cn`,
    wxAccount: 'xiaowei',
    env: 'yxvzbtest',
    ysh: `//ysh-wxv2.jimijiayuan.cn/html/newWechat.html?t=${Date.now()}/#/home?from=jhss`
  };
} else {
  // 线上
  difObj = {
    wxAppId: 'wxacc20a0bc3b828b0',
    webSocketPath: `${wsProtocol}://danmu.yxvzb.com`,
    wxAccount: 'frozenhome',
    env: 'yxvzb',
    ysh: `//wx.yxvzb.com/html/newWechat.html?t=${Date.now()}/#/home?from=jhss`
  };
}

let config = {
  wxAppId: '',
  webSocketPath: 'ws://danmu.yxvzb.com',
  wxAccount: '',
  domain: setDomain(),
  env: 'yxvzb',
  wxAuth(uri) {
    // 授权转跳使用中转页面
    let r = encodeURIComponent(
      `http://cdn.yxvzb.com/WEB/transfer/index.html?vue_redirect_url=${uri}`
    );
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.wxAppId}&redirect_uri=http%3a%2f%2f${window.location.host}%2frest%2fwxIndex%2fauthorizeCallback%3fredirectUri%3d${r}&response_type=code&scope=snsapi_userinfo&source_type=wx&state=3#wechat_redirect`;
  }
};
Object.assign(config, difObj);

export default config;
